import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const VENDOR_CONFIG = {
  "self-help-group": {
    title: "SHG Master",
    shortName: "SHG",
    vendor_type_id: 3,
  },
  "cluster-level-federation": {
    title: "CLF Master",
    shortName: "CLF",
    vendor_type_id: 1,
  },
  "area-level-federation": {
    title: "ALF Master",
    shortName: "ALF",
    vendor_type_id: 2,
  },
};

const VendorTypeMaster = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [filters, setFilters] = useState({ searchKey: "" });
  const [schoolList, setSchoolList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [clfList, setClfList] = useState([]);
  const [alfList, setAlfList] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const { vendorSlug } = useParams();
  const vendorConfig = VENDOR_CONFIG[vendorSlug];
  const navigate = useNavigate();
  const { title, vendor_type_id, shortName } = vendorConfig;

  const isCLF = vendor_type_id === 1;
  const isALF = vendor_type_id === 2;
  const isSHG = vendor_type_id === 3;

  const [formData, setFormData] = useState({
    vendor_type_id: "",
    parent_id: "",
    name: "",
    code: "",
    address: "",
    school_ids: [],
    id: ""
  });

  const fetchCLFs = async () => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        vendor_type_id: "1", // 👈 ALWAYS CLF
        page: "1",
        per_page: "100",
      };

      const res = await axios.post(`${BASE_URL}/vendorsList`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        transformRequest: [(data) => JSON.stringify(data)],
      });

      let list = [];

      if (Array.isArray(res?.data?.data)) {
        list = res.data.data;
      } else if (res?.data?.data?.r) {
        list = res.data.data.r;
      }

      setClfList(list);
    } catch (err) {
          if (handle401(err)) return;

      console.error("Fetch CLF error", err);
      setClfList([]);
    }
  };

  const fetchALFs = async () => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        vendor_type_id: "2", // 👈 ALWAYS ALF
        page: "1",
        per_page: "100",
      };

      const res = await axios.post(`${BASE_URL}/vendorsList`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        transformRequest: [(data) => JSON.stringify(data)],
      });

      let list = [];

      if (Array.isArray(res?.data?.data)) {
        list = res.data.data;
      } else if (res?.data?.data?.r) {
        list = res.data.data.r;
      }

      setAlfList(list);
    } catch (err) {
      if (handle401(err)) return;
      console.error("Fetch ALF error", err);
      setAlfList([]);
    }
  };

  useEffect(() => {
    if (isALF) {
      fetchCLFs();
    }
  }, [isALF]);

  useEffect(() => {
    if (isSHG) {
      fetchALFs();
    }
  }, [isSHG]);

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + maxPagesToShow - 1);

    if (end - start < maxPagesToShow - 1) {
      start = Math.max(1, end - maxPagesToShow + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const fetchVendors = async (
    pageNo = 1,
    searchValue = filters.searchKey,
    perPageValue = perPage
  ) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const payload = {
        vendor_type_id: String(vendor_type_id),
        searchKey: searchValue,
        page: pageNo,
        per_page: String(perPageValue),
      };

      console.log("PAYLOAD SENDING:", payload);
      const res = await axios.post(`${BASE_URL}/vendorsList`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        transformRequest: [(data) => JSON.stringify(data)], // 👈 OVERRIDE
      });

      let list = [];

      if (Array.isArray(res?.data?.data)) {
        list = res.data.data;
      } else if (res?.data?.data?.r) {
        // 👈 backend sends this format
        list = res.data.data.r;
      }

      const totalRecords = Number(res.data.total_records || 0);

      setVendorList(list);
      setPage(pageNo);
      setTotalPages(Math.ceil(totalRecords / perPage));
    } catch (error) {
              if (handle401(error)) return;

      console.error("Fetch Vendors Error:", error);
      setVendorList([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSchools = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/schoolList`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const schools = Array.isArray(res?.data?.data) ? res.data.data : [];

      setSchoolList(schools);

      console.log("FULL RESPONSE:", res.data);
      console.log("TYPE OF data:", typeof res.data.data);
      console.log("IS ARRAY:", Array.isArray(res.data.data));
    } catch (error) {

      console.error("Fetch Schools Error:", error);

      if (error.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
        navigate("/ulb/login");
      } else {
        Swal.fire("Error!", "Failed to load schools", "error");
      }

      setSchoolList([]); // safety fallback
    }
  };

  useEffect(() => {
    if (!vendor_type_id) return;

    fetchVendors(1);

    if (vendor_type_id === 3) {
      fetchSchools();
    } else {
      setSchoolList([]);
    }
  }, [vendor_type_id]);

  const openAddModal = () => {
    setShowModal(true);
    setIsEdit(false);
    setFormData({
      vendor_type_id: "",
    parent_id: "",
    name: "",
    code: "",
    address: "",
    school_ids: [],
    id: "" // ✅ MUST BE HERE
    });
  };

  const openEditModal = (row) => {
  setShowModal(true);
  setIsEdit(true);
  setEditId(row.id);

  setFormData({
    vendor_type_id: String(vendor_type_id),
    parent_id: row.parent_id ? String(row.parent_id) : "",
    name: row.vendors_master_name || "",
    code: row.code || "",
    address: row.address || "",
    contact_no: row.contact_no,
    school_ids: Array.isArray(row.schools)
      ? row.schools.map(s => String(s.school_id))
      : [],
    id: row.id // ✅ IMPORTANT
  });
};



const submitVendor = async () => {
  try {
    const token = localStorage.getItem("token");

    // Validation
    if ((isALF || isSHG) && !formData.parent_id) {
      return Swal.fire(
        "Validation Failed",
        `Please select ${isALF ? "CLF" : "ALF"}`,
        "warning"
      );
    }
    if (!formData.name) {
      return Swal.fire("Validation Failed", "Name is required", "warning");
    }
    if (!formData.code) {
      return Swal.fire("Validation Failed", "Code is required", "warning");
    }
    if ((isCLF || isALF) && !formData.address) {
      return Swal.fire("Validation Failed", "Address is required", "warning");
    }

    // Build payload
    const payload = {
      vendor_type_id: String(vendor_type_id),
      name: formData.name,
      code: formData.code,
      contact_no: formData.contact_no,
    };

    if (isCLF || isALF) payload.address = formData.address;
    if (isALF || isSHG) payload.parent_id = String(formData.parent_id);
    if (isSHG) {
      payload.school_ids = formData.school_ids;
      payload.address = formData.address || "";
    }

    if (isEdit && editId) payload.id = String(editId);

    console.log("FINAL PAYLOAD:", payload);

    const res = await axios.post(`${BASE_URL}/vendorsAddEdit`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Success", res.data.message, "success");
    setShowModal(false);
    fetchVendors(page, filters.searchKey, perPage);
  } catch (error) {
    console.error("Add/Edit Vendor Error:", error);
    const backendMessage =
      error.response?.data?.message || "Failed to save vendor";

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", backendMessage, "warning");
      localStorage.clear();
      navigate("/ulb/login");
    } else {
      Swal.fire("Validation Failed", backendMessage, "warning");
    }
  }
};


useEffect(() => {
  if (!vendor_type_id) return;

  fetchVendors(1, filters.searchKey, perPage);
}, [perPage]);





  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* ✅ HEADER SAME AS CLF */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> {title}
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={filters.searchKey}
                  onChange={(e) =>
                    setFilters({ ...filters, searchKey: e.target.value })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* ✅ SEARCH & RESET SAME AS CLF */}
            <Col md={4} className="d-flex gap-3 mt-3">
              <Button
                className="w-50 fw-semibold text-white"
                style={{ background: "#1565C1", borderRadius: "10px" }}
                onClick={() => fetchVendors(1, filters.searchKey)}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              <Button
                className="w-50 fw-semibold text-white"
                style={{ background: "#E53935", borderRadius: "10px" }}
                onClick={() => {
                  setFilters({ searchKey: "", district_id: "" });
                  setPerPage(10);
                  setPage(1);
                  fetchVendors(1, "", 10);
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Button
        className="mb-3 px-4 text-white fw-semibold"
        onClick={openAddModal}
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add {shortName}
      </Button>

      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>

          <div className="loading-line">
            <div className="loading-progress"></div>
          </div>

          <p className="loading-text">Loading, please wait...</p>
        </div>
      )}
      {/* ✅ TABLE SAME AS CLF */}
      {!loading && (
        <Card
          className="mb-4 border-0"
          style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
            overflow: "hidden",
          }}
        >
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SL
                </th>

                {(isSHG || isALF) && (
  <th
    style={{
      padding: "5px",
      fontWeight: "600",
      letterSpacing: "0.5px",
      borderTopLeftRadius: "10px",
      backgroundColor: "#edf7fe",
      height: "10px",
      borderBottom: "1px solid black",
      borderTop: "1px solid black",
      textAlign: "center",
    }}
  >
    {isSHG ? "ALF" : "CLF"}
  </th>
)}


                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Name
                </th>

                {
                    !isSHG && (
                        <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Address
                </th>
                    )
                }

                {isSHG && (
                    <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Schools
                </th>
                )

                }
                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {vendorList.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    No data found
                  </td>
                </tr>
              ) : (
                vendorList.map((item, index) => (
                  <tr key={item.id || index}>
                     <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>
                    {(isSHG || isALF) && (
  <td className="text-center">
    {item.parent_name || "-"}
  </td>
)}

                    <td className="text-center">
                      {item.vendors_master_name || "-"}
                    </td>
                    {
                        !isSHG && (<td className="text-center">
                            {item.address || "-"}
                        </td>)


                    }


                    {
                        isSHG && (
                            <td className="text-center" style={{fontSize: "14px",width: "50%"}}>
                      {item.schools && item.schools.length> 0 ? item.schools.map(s => s.name).join(","): '-'}
                    </td>
                        )
                    }
                    <td className="text-center">
                      <Button
                        size="sm"
                        className="me-2"
                        style={{
                          background: "#1565C1",
                          border: "none",
                          padding: "6px 10px",
                          boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#0D47A1")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#1565C1")
                        }
                        onClick={() => openEditModal(item)}
                      >
                        <i className="fa-solid fa-pen text-white"></i>
                      </Button>

                      {/* DELETE */}
                      <Button
                        size="sm"
                        style={{
                          background:
                            "linear-gradient(90deg, #E53935, #D32F2F)",
                          border: "none",
                          padding: "6px 10px",
                          boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background =
                            "linear-gradient(90deg, #D32F2F, #B71C1C)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background =
                            "linear-gradient(90deg, #E53935, #D32F2F)")
                        }
                        onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                      >
                        <i className="fa-solid fa-trash-can text-white"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination shadow-sm">
                  {/* First */}
                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchVendors(1)}
                    >
                      «
                    </button>
                  </li>

                  {/* Prev */}
                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchVendors(page - 1)}
                    >
                      ‹
                    </button>
                  </li>

                  {/* Page Numbers */}
                  {getPageNumbers().map((p) => (
                    <li
                      key={p}
                      className={`page-item ${page === p ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => fetchVendors(p)}
                      >
                        {p}
                      </button>
                    </li>
                  ))}

                  {/* Next */}
                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchVendors(page + 1)}
                    >
                      ›
                    </button>
                  </li>

                  {/* Last */}
                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchVendors(totalPages)}
                    >
                      »
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </Card>
      )}

      {/* ✅ MODAL SAME AS CLF */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "white" }}
        >
          <Modal.Title>
            {isEdit ? `Edit ${shortName}` : `Add ${shortName}`}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* ===== CLF DROPDOWN (ALF only) ===== */}
          {isALF && (
  <div>
    <Form.Group className="mb-3">
    <Form.Label>
      CLF <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <Form.Select
      value={formData.parent_id}
      onChange={(e) =>
        setFormData({ ...formData, parent_id: e.target.value })
      }
    >
      <option value="">Select CLF</option>
      {clfList.map((clf) => (
        <option key={clf.id} value={clf.id}>
          {clf.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>


  </div>


)}


          {/* ===== ALF DROPDOWN (SHG only) ===== */}
          {isSHG && (
  <Form.Group className="mb-3">
    <Form.Label>
      ALF <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <Form.Select
      value={formData.parent_id}
      onChange={(e) =>
        setFormData({ ...formData, parent_id: e.target.value })
      }
    >
      <option value="">Select ALF</option>
      {alfList.map((alf) => (
        <option key={alf.id} value={alf.id}>
          {alf.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
)}


          {/* ===== NAME FIELD (ALL) ===== */}
          <Form.Group className="mb-3">
            <Form.Label>
              {shortName} Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              placeholder={`${shortName} Name`}
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
  <Form.Label>
    {shortName} Code{" "}

      <span style={{ color: "red" }}>*</span>

  </Form.Label>

  <Form.Control
    type="text"
    placeholder={`Enter ${shortName} Code`}
    value={formData.code}
    onChange={(e) =>
      setFormData({ ...formData, code: e.target.value })
    }
  />
</Form.Group>



          {/* ===== ADDRESS (ALL) ===== */}

            {!isSHG && (
                <div>

                    <Form.Group className="mb-3">
  <Form.Label>
    Mobile Number <span className="text-muted">(Optional)</span>
  </Form.Label>

  <Form.Control
    type="tel"
    placeholder="Enter Mobile Number"
    maxLength={10}
    value={formData.contact_no || ""}
    onChange={(e) =>
      setFormData({ ...formData, contact_no: e.target.value })
    }
  />
</Form.Group>


                    <Form.Group className="mb-3">
              <Form.Label>Address <span style={{ color: "red" }}>*</span></Form.Label>
              <Form.Control
                placeholder="Address"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
              />
            </Form.Group>
                </div>
            )

            }


          {/* ===== SCHOOL MULTI SELECT (SHG only) ===== */}
          {isSHG && (
            <Form.Group className="mb-3">
              <Form.Label>
                Schools <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Select
                isMulti
                options={schoolList.map((s) => ({
                  value: s.id,
                  label: s.name,
                }))}
                value={schoolList
                  .filter((s) => formData.school_ids.includes(String(s.id)))
                  .map((s) => ({
                    value: s.id,
                    label: s.name,
                  }))}
                onChange={(selected = []) => {
                  setFormData({
                    ...formData,
                    school_ids: selected.map((item) => String(item.value)),
                  });
                }}
              />
            </Form.Group>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={() => setShowModal(false)}
            className="btn btn-danger text-white"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={submitVendor}
            className="text-white"
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VendorTypeMaster;
